// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1cfyI","left":"StickyBox_left__3eGOK","right":"StickyBox_right__3Rwlg"};